<template>

    <div class="modal modal-question fade in show" :id="modalId" tabindex="-1" role="dialog" :aria-labelledby="modalId" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                <div class="modal-inner">
                    <h5 class="title">{{ currentItem ? 'Edit' : 'Create' }}</h5>
                    <div class="form">
                        <form action="">
                            <label class="form-group mb-3">
                                <span class="form-label">Title of the Menu Item</span>
                                <input type="text" class="form-control pl-4" v-model="form.title">
                            </label>
                            <label class="form-group mb-3">
                                <span class="form-label">Link type (Static URL  or  Page)</span>
                                <select class="custom-select pl-4" v-model="linkType">
                                    <option :value="null">Select One</option>
                                    <option value="page">Page</option>
                                    <option value="url">Static URL</option>
                                </select>
                            </label>
                            <label class="form-group mb-3" v-if="linkType === 'page'">
                                <span class="form-label">Page for the menu item</span>
                                <select class="custom-select pl-4" v-model="form.page_id">
                                    <option :value="null">Select One</option>
                                    <option
                                        v-for="page in pages"
                                        :key="page.id"
                                        :value="page.id"
                                    >{{page.name}}</option>
                                </select>
                            </label>
                            <label class="form-group mb-3" v-else>
                                <span class="form-label">Url for the menu item</span>
                                <input class="custom-select pl-4" v-model="form.url">
                            </label>
                            <label class="form-group mb-3">
                                <span class="form-label">Open In (Same tab/window  or  New tab/window)</span>
                                <select class="custom-select pl-4" v-model="form.target">
                                    <option :value="null">Select One</option>
                                    <option value="same">Same tab</option>
                                    <option value="new">New tab</option>
                                </select>
                            </label>
                            <div class="buttons mt-4">
                                <button
                                    class="btn btn_primary-outline pl-5 pr-5"
                                    @click="closeModal"
                                > {{ rejectText }}</button>
                                <button
                                    class="btn btn_golden"
                                    @click.prevent="confirmation"
                                >
                                    <span class="pl-5 pr-5">{{ confirmText }}</span>
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

export default {
    name: 'ModalMenuItem',
    props: {
        confirmText: String,
        modalId: {
            type: String,
            required: true,
        },
        rejectText: String,
        currentItem: Object,
        pages: Array
    },
    emits: ['confirm'],
    data() {
        return {
            linkType: null,
            form: {
                id: null,
                title: null,
                url: null,
                target: null,
                order: null,
                page_id: null,
                menu_id: null,
            }
        }
    },
    methods: {
        closeModal() {
            $(`#${this.modalId}`).modal('hide');
            this.form = {}
        },
        confirmation () {
            this.$emit('confirm', this.form);
            this.closeModal()
        }
    },
    mounted() {
        if(this.currentItem) {
            this.form = this.currentItem
        }
    }
}

</script>



<style scoped>

</style>
